<div [formGroup]="form">
<div class="row">
    <div class="col-md-12 col-xs-12 group-title">
        <h5>רשימת מקומות תעסוקה ב-5 שנים אחרונות בהם עבדת בחו"ל</h5>
    </div>
</div>
<div class="row controls-group">
    <div class="col-md-12 col-xs-12" >
        <p> <span class='colorred'>חשוב! </span>חובה למלא את כל מקומות העבודה ב-5 השנים האחרונות (בחו"ל)</p>
        <a [routerLink]="" queryParamsHandling="preserve" (click)="openJobListDetailsPopup()">לחץ לפרטים נוספים</a>
        <div class="input-group">
            <div formArrayName="lastWorkItems" *ngFor="let item of lastWorkItems.controls; let i = index;">
                <div  [formGroupName]="i">
                    <div class="row mt-10">
                        <div class="col-md-1 col-xs-1">
                            <div class="mt-10"> 
                                <label class="mt-10">                        
                                    <div class="input-group">
                                        <button class="btn icon" [disabled]="i==0" (click)="removeWorkItem(i)">X</button>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-3 col-xs-11">
                            <div >                        
                                <label mandatory>
                                    קשר משפחתי
                                </label>
                                <div class="input-group">
                                    <select class="form-control" formControlName="family_relation" id="{{'family_relation' + i}}" >
                                    <option *ngFor="let item of ddlFamily" value="{{item.KOD}}">{{item.TEUR}}</option>
                                    </select>
                                    <control-messages [control]="f2[i].controls.family_relation"></control-messages>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-xs-6">
                            <div>                        
                                <label mandatory>
                                    שם מקום העבודה
                                </label>
                                <div class="input-group">
                                    <input type="text" class="form-control txt" maxlength="35" 
                                        formControlName="job_place"
                                    />
                                    <control-messages [control]="f2[i].controls.job_place"></control-messages>
                                </div>
                                <label class="form-radio-label">                           
                                    <input type="checkbox" formControlName="didnt_work" (change)="checkDidntWork(i)">
                                    <span class="checkmark"></span> לא עבד/תי                                 
                                </label>
                            </div>    
                        </div>
                        <div class="col-md-4 col-xs-6">
                            <div>                        
                                <label mandatory>
                                    תאריך סיום
                                </label>
                                <div class="input-group">
                                    <input type="text" class="form-control datepicker" autocomplete="off" 
                                        bsDatepicker [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                                        #dpd="bsDatepicker" formControlName="finish_date" 
                                    >
                                    <span class="input-group-prepend">
                                        <span class="input-group-text" >
                                            <i class="fa fa-calendar"></i>
                                        </span>
                                    </span>
                                    
                                    <control-messages [control]="f2[i].controls.finish_date"></control-messages>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <div class="input-group">
                            <button class="btn small" (click)="addWorkItem()">הוסף</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-popup-box [message]="message" [title]="msgBoxTitle" (closed)="message=''"></app-popup-box>
</div>